module.exports = __webpack_public_path__ + "img/file-earmark-plus.b9fd92ec.svg";